import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

/**
 * Native checkbox styled to the design tokens. Kept native on purpose: it works with react-hook-form's
 * `register`, keyboard and screen readers without any extra wiring.
 */
export function Checkbox({ className, ...props }: Omit<ComponentProps<"input">, "type">) {
  return (
    <input
      type="checkbox"
      className={cn(
        "size-4 shrink-0 cursor-pointer rounded border border-input accent-primary",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
